import palette from './palette';

// Gym Fitness Tracker Design System - Manrope Font
export default {
  fontFamily: [
    'Manrope',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif'
  ].join(','),
  // Display - text-4xl / 800 / 36px
  h1: {
    color: palette.text.primary,
    fontWeight: 800,
    fontSize: '36px',
    letterSpacing: '-0.02em',
    lineHeight: '44px'
  },
  // Heading 1 - text-3xl / 800 / 30px
  h2: {
    color: palette.text.primary,
    fontWeight: 800,
    fontSize: '30px',
    letterSpacing: '-0.01em',
    lineHeight: '38px'
  },
  // Heading 2 - text-2xl / 800 / 24px
  h3: {
    color: palette.text.primary,
    fontWeight: 800,
    fontSize: '24px',
    letterSpacing: '-0.01em',
    lineHeight: '32px'
  },
  // Heading 3 - text-xl / 800 / 20px
  h4: {
    color: palette.text.primary,
    fontWeight: 800,
    fontSize: '20px',
    letterSpacing: '0',
    lineHeight: '28px'
  },
  // Heading 4 - text-lg / 700 / 18px
  h5: {
    color: palette.text.primary,
    fontWeight: 700,
    fontSize: '18px',
    letterSpacing: '0',
    lineHeight: '26px'
  },
  // Body Emphasis - text-base / 800 / 16px
  h6: {
    color: palette.text.primary,
    fontWeight: 800,
    fontSize: '16px',
    letterSpacing: '0',
    lineHeight: '24px'
  },
  // Body - text-sm / 600 / 14px
  subtitle1: {
    color: palette.text.primary,
    fontSize: '14px',
    fontWeight: 600,
    letterSpacing: '0',
    lineHeight: '20px'
  },
  // Body - text-sm / 600 / 14px (secondary color)
  subtitle2: {
    color: palette.text.secondary,
    fontWeight: 600,
    fontSize: '14px',
    letterSpacing: '0',
    lineHeight: '20px'
  },
  // Body - text-sm / 600 / 14px
  body1: {
    color: palette.text.primary,
    fontSize: '14px',
    fontWeight: 600,
    letterSpacing: '0',
    lineHeight: '20px'
  },
  // Caption - text-xs / 500 / 12px
  body2: {
    color: palette.text.disabled,
    fontSize: '12px',
    fontWeight: 500,
    letterSpacing: '0',
    lineHeight: '16px'
  },
  // Button text
  button: {
    color: palette.text.primary,
    fontSize: '14px',
    fontWeight: 700,
    letterSpacing: '0',
    lineHeight: '20px',
    textTransform: 'none'
  },
  // Caption - text-xs / 500 / 12px
  caption: {
    color: palette.text.disabled,
    fontSize: '12px',
    fontWeight: 500,
    letterSpacing: '0',
    lineHeight: '16px'
  },
  // Overline for section headers
  overline: {
    color: palette.text.secondary,
    padding: '8px',
    fontSize: '11px',
    paddingRight: '8px',
    fontWeight: 700,
    letterSpacing: '0.05em',
    lineHeight: '16px',
    textTransform: 'uppercase'
  }
};
